import client from './client';
import { Employee, PaginatedResponse } from '../types';

export const employeesApi = {
  list: (params?: {
    page?: number;
    per_page?: number;
    search?: string;
    department?: string;
    contract_type?: string;
    status?: string;
  }) => client.get<PaginatedResponse<Employee>>('/employees', { params }),

  get: (id: string) => client.get<Employee>(`/employees/${id}`),

  create: (data: Partial<Employee>) =>
    client.post<Employee>('/employees', data),

  update: (id: string, data: Partial<Employee>) =>
    client.put<Employee>(`/employees/${id}`, data),

  delete: (id: string) => client.delete(`/employees/${id}`),

  stats: () =>
    client.get<{
      total: number;
      by_department: Record<string, number>;
      by_contract: Record<string, number>;
      by_status: Record<string, number>;
    }>('/employees/stats'),

  directory: (params?: { search?: string; department?: string; page?: number; per_page?: number }) =>
    client.get<{
      success: boolean;
      data: {
        contacts: DirectoryContact[];
        total: number;
        page: number;
        pages: number;
        departments: string[];
      };
    }>('/employees/directory', { params }),
};

export interface DirectoryContact {
  id: number;
  first_name: string;
  last_name: string;
  full_name: string;
  email?: string | null;
  position?: string | null;
  department?: string | null;
  manager_name?: string | null;
}
